// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 9999px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}
.filter-tab:hover {
  border-color: #3b82f6;
  color: #1d4ed8;
}
.filter-tab.active {
  border-color: #2563eb;
  background: #eff6ff;
  color: #1d4ed8;
  font-weight: 600;
}

.tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9999px;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 11px;
  font-weight: 600;
}
.active .tab-count {
  background: #dbeafe;
  color: #1d4ed8;
}

.alarms-table {
  border-collapse: collapse;
  font-size: 13px;
  width: 100%;
}
.alarms-table th {
  padding: 10px 14px;
  background: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
  font-weight: 600;
  color: #374151;
  text-align: left;
  white-space: nowrap;
}
.alarms-table td {
  padding: 10px 14px;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
}
.alarms-table tbody tr:last-child td {
  border-bottom: none;
}
.alarms-table tbody tr:hover td {
  background: #fafafa;
}
.alarms-table tbody tr.row-active td {
  background: #fff5f5;
}
.alarms-table tbody tr.row-active:hover td {
  background: #fee2e2;
}

.priority-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.priority-badge.priority-high {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}
.priority-badge.priority-medium {
  background: #fef3c7;
  color: #b45309;
  border: 1px solid #fcd34d;
}
.priority-badge.priority-low {
  background: #d1fae5;
  color: #065f46;
  border: 1px solid #6ee7b7;
}

.state-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.state-chip.state-active {
  background: #fee2e2;
  color: #dc2626;
  border: 1px solid #fca5a5;
}
.state-chip.state-ceased {
  background: #f3f4f6;
  color: #6b7280;
  border: 1px solid #d1d5db;
}
.state-chip.state-acknowledged {
  background: #dbeafe;
  color: #1d4ed8;
  border: 1px solid #93c5fd;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}
.action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.action-btn.action-acknowledge {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #1d4ed8;
}
.action-btn.action-acknowledge:hover:not(:disabled) {
  background: #dbeafe;
  border-color: #3b82f6;
}
.action-btn.action-reset {
  background: #fff7ed;
  border-color: #fdba74;
  color: #c2410c;
}
.action-btn.action-reset:hover:not(:disabled) {
  background: #ffedd5;
  border-color: #fb923c;
}`, "",{"version":3,"sources":["webpack://./src/app/features/alarms/alarms.scss"],"names":[],"mappings":"AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAAF;AAEE;EACE,qBAAA;EACA,cAAA;AAAJ;AAGE;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AADJ;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAFF;AAIE;EACE,mBAAA;EACA,cAAA;AAFJ;;AAOA;EACE,yBAAA;EACA,eAAA;EACA,WAAA;AAJF;AAME;EACE,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,gCAAA;EACA,sBAAA;AALJ;AAQE;EACE,mBAAA;AANJ;AASE;EACE,mBAAA;AAPJ;AAUE;EACE,mBAAA;AARJ;AAWE;EACE,mBAAA;AATJ;;AAcA;EACE,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAXF;AAaE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAXJ;AAcE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAZJ;AAeE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAbJ;;AAkBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAfF;AAiBE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAfJ;AAkBE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAhBJ;AAmBE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAjBJ;;AAsBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;AAnBF;AAqBE;EACE,YAAA;EACA,mBAAA;AAnBJ;AAsBE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AApBJ;AAsBI;EACE,mBAAA;EACA,qBAAA;AApBN;AAwBE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAtBJ;AAwBI;EACE,mBAAA;EACA,qBAAA;AAtBN","sourcesContent":["// Filter tabs\n.filter-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 9999px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &:hover {\n    border-color: #3b82f6;\n    color: #1d4ed8;\n  }\n\n  &.active {\n    border-color: #2563eb;\n    background: #eff6ff;\n    color: #1d4ed8;\n    font-weight: 600;\n  }\n}\n\n.tab-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 9999px;\n  background: #f3f4f6;\n  color: #6b7280;\n  font-size: 11px;\n  font-weight: 600;\n\n  .active & {\n    background: #dbeafe;\n    color: #1d4ed8;\n  }\n}\n\n// Alarms table\n.alarms-table {\n  border-collapse: collapse;\n  font-size: 13px;\n  width: 100%;\n\n  th {\n    padding: 10px 14px;\n    background: #f9fafb;\n    border-bottom: 2px solid #e5e7eb;\n    font-weight: 600;\n    color: #374151;\n    text-align: left;\n    white-space: nowrap;\n  }\n\n  td {\n    padding: 10px 14px;\n    border-bottom: 1px solid #f3f4f6;\n    vertical-align: middle;\n  }\n\n  tbody tr:last-child td {\n    border-bottom: none;\n  }\n\n  tbody tr:hover td {\n    background: #fafafa;\n  }\n\n  tbody tr.row-active td {\n    background: #fff5f5;\n  }\n\n  tbody tr.row-active:hover td {\n    background: #fee2e2;\n  }\n}\n\n// Priority badges\n.priority-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n\n  &.priority-high {\n    background: #fee2e2;\n    color: #b91c1c;\n    border: 1px solid #fca5a5;\n  }\n\n  &.priority-medium {\n    background: #fef3c7;\n    color: #b45309;\n    border: 1px solid #fcd34d;\n  }\n\n  &.priority-low {\n    background: #d1fae5;\n    color: #065f46;\n    border: 1px solid #6ee7b7;\n  }\n}\n\n// State chips\n.state-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n\n  &.state-active {\n    background: #fee2e2;\n    color: #dc2626;\n    border: 1px solid #fca5a5;\n  }\n\n  &.state-ceased {\n    background: #f3f4f6;\n    color: #6b7280;\n    border: 1px solid #d1d5db;\n  }\n\n  &.state-acknowledged {\n    background: #dbeafe;\n    color: #1d4ed8;\n    border: 1px solid #93c5fd;\n  }\n}\n\n// Action buttons\n.action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 10px;\n  border-radius: 6px;\n  border: 1px solid;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &.action-acknowledge {\n    background: #eff6ff;\n    border-color: #93c5fd;\n    color: #1d4ed8;\n\n    &:hover:not(:disabled) {\n      background: #dbeafe;\n      border-color: #3b82f6;\n    }\n  }\n\n  &.action-reset {\n    background: #fff7ed;\n    border-color: #fdba74;\n    color: #c2410c;\n\n    &:hover:not(:disabled) {\n      background: #ffedd5;\n      border-color: #fb923c;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
